import type { StoreType } from "./storeTypes"

import barberShop from "@bounce/assets/images/store-types/barber-shop.jpg"
import beautySalon from "@bounce/assets/images/store-types/beauty-salon.jpg"
import bikeShop from "@bounce/assets/images/store-types/bike-shop.jpg"
import cafe from "@bounce/assets/images/store-types/cafe.jpg"
import convenienceStore from "@bounce/assets/images/store-types/convenience-store.jpg"
import deli from "@bounce/assets/images/store-types/deli.jpg"
import dessertShop from "@bounce/assets/images/store-types/dessert-shop.jpg"
import dryCleaner from "@bounce/assets/images/store-types/dry-cleaner.jpg"
import other from "@bounce/assets/images/store-types/generic-store.jpg"
import gym from "@bounce/assets/images/store-types/gym.jpg"
import hardwareStore from "@bounce/assets/images/store-types/hardware-store.jpg"
import hotel from "@bounce/assets/images/store-types/hotel.jpg"
import karaoke from "@bounce/assets/images/store-types/karaoke.jpg"
import pharmacy from "@bounce/assets/images/store-types/pharmacy.jpg"
import printShop from "@bounce/assets/images/store-types/print-shop.jpg"
import restaurant from "@bounce/assets/images/store-types/restaurant.jpg"
import retailStore from "@bounce/assets/images/store-types/retail-store.jpg"
import tattooShop from "@bounce/assets/images/store-types/tattoo-shop.jpg"
import upsStore from "@bounce/assets/images/store-types/ups-store.jpg"
import wellness from "@bounce/assets/images/store-types/wellness.jpg"

export const StoreTypeImages = {
  "Beauty Salon": beautySalon,
  "Bike Rental": bikeShop,
  "Car Rental": other,
  "Convenience Store": convenienceStore,
  Deli: deli,
  "Dessert Shop": dessertShop,
  "Dry Cleaner": dryCleaner,
  "Fitness Center": gym,
  "Hardware Store": hardwareStore,
  Hotel: hotel,
  Karaoke: karaoke,
  Pharmacy: pharmacy,
  Restaurant: restaurant,
  "Tattoo Parlor": tattooShop,
  "Wellness Center": wellness,
  "The UPS Store": upsStore,
  "Retail Store": retailStore,
  Bar: cafe,
  Cafe: cafe,
  "Barber Shop": barberShop,
  "Hair Salon": barberShop,
  Office: printShop,
  "Print Shop": printShop,
  "Shipping Store": printShop,
  "Stationary Store": printShop,
  "Electronics Store": other,
  "Luggage Storage": other,
  "Smoke Shop": other,
  "Souvenir Shop": other,
  "Travel Agency": other,
  "Adult Store": other,
  Other: other,
}

export const resolveStoreTypeImage = (type: string) => {
  return type in StoreTypeImages ? StoreTypeImages[type as StoreType] : StoreTypeImages.Other
}
